export default __webpack_public_path__ + "static/dashboard.ko-0f8e00c2c8282525c05c350c517ff9a9.svg";